// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2vykP","buttons":"RemoveExpirationActionButtons_buttons__K9ELR"};